import { buildImageUrl } from "@/config/images";
import type { Seed, SeedCreatePayload, SeedUpdatePayload } from "@/types";
import Repository from "./repository";

const resource = "/seeds";

export default {
  async getAll(): Promise<Seed[]> {
    const { data } = await Repository.get(`${resource}/`);
    return data.map((seed: Seed): Seed => {
      if (seed.image_name) {
        seed.imageUrl = buildImageUrl(470, seed.image_name);
      }
      return seed;
    });
  },
  async get(seedId: number): Promise<Seed> {
    const { data } = await Repository.get(`${resource}/${seedId}/`);
    if (data.image_name) {
      data.imageUrl = buildImageUrl(470, data.image_name);
    }
    return data;
  },
  update(seedId: number, data: SeedUpdatePayload) {
    return Repository.patch(`${resource}/${seedId}/`, data);
  },
  delete(seedId: number) {
    return Repository.delete(`${resource}/${seedId}/`);
  },
  create(seed: SeedCreatePayload) {
    return Repository.post(`${resource}/`, seed);
  },
};
